import { useState } from "react";
import { APP_KEY_IDS } from "../../../constants/constants";
import BaseMobileAppContainer from "../base-mobile-app-container/BaseMobileAppContainer";
import Styles from "./SamsungBrowser.module.scss";
import classnames from "classnames"
import { ReactComponent as SearchIcon } from "../../../icons/extra_icons/search.svg"
import GooglePoster from "../../../icons/extra_icons/google_sample_art.gif"

const SamsungBrowser = () => {

  const [googleBanner, setGoogleBanner] = useState(true)

  const handleFrameClick = () => {
    setGoogleBanner(false)
  }

  const menuOptions = [
    {
      id: 0,
      label: "Youtube",
      link: "https://www.youtube.com/",
      icon: "https://m.youtube.com/static/favicon.ico"
    },
    {
      id: 1,
      label: "Samsung",
      link: "https://www.samsung.com/in/",
      icon: "https://www.samsung.com/etc.clientlibs/samsung/clientlibs/consumer/global/clientlib-common/resources/images/Favicon.png"
    },
    {
      id: 2,
      label: "Google",
      link: "https://www.google.com/",
      icon: "https://www.google.com/images/branding/product/1x/gsa_android_144dp.png"
    },
    {
      id: 3,
      label: "Bing",
      link: "https://www.bing.com/",
      icon: "https://bing.com/sa/simg/favicon-trans-bg-blue-mg-png.png"
    },
    {
      id: 4,
      label: "Wikipedia",
      link: "https://www.wikipedia.org/",
      icon: "https://www.wikipedia.org/static/favicon/wikipedia.ico"
    },
    {
      id: 5,
      label: "Facebook",
      link: "https://www.facebook.com/",
      icon: "https://static.xx.fbcdn.net/rsrc.php/v3/yj/r/gB76kJXPYJV.png"
    },
    {
      id: 6,
      label: "Twitter",
      link: "https://twitter.com/",
      icon: "https://abs.twimg.com/responsive-web/client-web/icon-ios.b1fc727a.png"
    },
    {
      id: 7,
      label: "LinkedIn",
      link: "https://www.linkedin.com/",
      icon: "https://firebasestorage.googleapis.com/v0/b/priyanshdatyal-me.appspot.com/o/Extra%20Logos%2Flinkedin.ico?alt=media&token=9eefb7b7-00ef-4c05-936d-ec611fc2965b"
    },
    {
      id: 8,
      label: "BBC",
      link: "https://www.bbc.com/",
      icon: "https://gn-web-assets.api.bbc.com/wwhp/20230426-1607-caf6673ae7b1ed935c3a5a0c53088749118d68b6/responsive/img/apple-touch/apple-touch-180.jpg"
    },
    {
      id: 9,
      label: "Github",
      link: "https://github.com/",
      icon: "https://github.com/fluidicon.png"
    },
    {
      id: 10,
      label: "priyanshdatyalclicks",
      link: "https://priyanshdatyalclicks.web.app/",
      icon: "https://priyanshdatyalclicks.web.app/logo.png"
    },

  ]

  return (
    <BaseMobileAppContainer
      appId={APP_KEY_IDS.MOBILE_BROWSER}
      title={""}
      MainScreen={
        <div className={Styles.full_page}>
          {googleBanner &&
            <>
              <div className={Styles.google_banner}>

                <img src={GooglePoster} />
                <div className={Styles.text}>

                  <span style={{ color: "#4285F4" }}>G</span>
                  <span style={{ color: "#EA4335" }}>o</span>
                  <span style={{ color: "#FBBC05" }}>o</span>
                  <span style={{ color: "#4285F4" }}>g</span>
                  <span style={{ color: "#34A853" }}>l</span>
                  <span style={{ color: "#EA4335" }}>e</span>

                </div>
              </div>
              <div onClick={handleFrameClick} className={Styles.search_container} >
                <input onClick={handleFrameClick} />
                <div className={Styles.icon}>
                  <SearchIcon />
                </div>
              </div>
              <div className={Styles.direct_links_container}>
                {menuOptions.map((option: any) => {
                  return (
                    <a className={Styles.direct_link_option} href={option.link} target="_blank" key={option.id}>
                        <img src={option.icon}/>
                        <div className={Styles.label}>
                          {option.label}
                        </div>
                    </a>
                  )
                })}
              </div>
            </>
          }
          <iframe className={classnames(Styles.frame, googleBanner && Styles.hidden_frame)} name="brow" src="./browserbase.html"  ></iframe>
        </div>

      }
      isMainScreenActive={true}
    />
  )
}

export default SamsungBrowser
